// extracted by mini-css-extract-plugin
export default {"container":"mq-z","brandName":"nq-z","productName":"oq-z","productNamePdpEnhancements":"pq-z","breakLongProductName":"qq-z"};